import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {ConnectionCriteria} from './ConnectionCriteria';
import {DatabaseConnection} from '../message/DatabaseConnection';

export class DatabaseConnectionWrapper extends BaseWrapper<DatabaseConnection, ConnectionCriteria, BasicScenario>  {}

